import React, { useMemo } from "react";
import objectPath from "object-path";
import { Link, NavLink } from "react-router-dom";

import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Brand } from "../brand/Brand";

import { AsideMenu } from "./aside-menu/AsideMenu";

export function Aside() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      disableScroll:
        objectPath.get(uiService.config, "aside.menu.dropdown") === "true" ||
        false,
      asideClassesFromConfig: uiService.getClasses("aside", true),
      disableAsideSelfDisplay:
        objectPath.get(uiService.config, "aside.self.display") === false,
      headerLogo: uiService.getLogo()
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        className={`aside aside-left  ${layoutProps.asideClassesFromConfig} d-flex flex-column h-100`}
      >
        <Brand />

        <div id="kt_aside_menu_wrapper" className="aside-menu-wrapper flex-grow-1 pb-10" >
          {layoutProps.disableAsideSelfDisplay && (
            <>
              <div className="header-logo">
                <Link to="">
                  <img alt="logo" src={layoutProps.headerLogo} />
                </Link>
              </div>
            </>
          )}
          <AsideMenu disableScroll={layoutProps.disableScroll} />
        </div>

        <div style={{ height: 100 }}>
          <ul className={`menu-nav menu-nav-logout`}>

            <li className={`menu-item `} >
              <NavLink className="menu-link menu-link-logout" to="/logout">
                <i className="bi-power menu-icon icon-xl menu-icon-style"></i>
                <span className="menu-text menu-text-logout notabsolute menu-custom-text">Logout</span>
              </NavLink>
            </li>
          </ul>

          <div className='app-version'>
            v{process.env.REACT_APP_VERSION}
          </div>
        </div>
      </div>
    </>
  );
}
